(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-subscription"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-subscription-page]').forEach((page) => {
    const variantId = page.querySelector('[data-subscription-variant-id]');
    const price = page.querySelector('[data-subscription-price]');
    const grind = page.querySelector('.sub-grind');
    const button = page.querySelector('.sub-form button');
    const formats = page.querySelectorAll('input[name="subscription-format"]');
    const updateVariant = () => {
      const format = page.querySelector('input[name="subscription-format"]:checked');
      if (!format || !grind) return;
      const key = grind.value.toLowerCase();
      variantId.value = format.dataset[`${key}Id`];
      price.textContent = format.dataset[`${key}Price`];
      button.disabled = format.dataset[`${key}Available`] !== 'true';
    };
    formats.forEach((input) => input.addEventListener('change', updateVariant));
    grind?.addEventListener('change', updateVariant);
    updateVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["world-order"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-id]').forEach((section) => {
    const variantId = section.querySelector('.wo__variant-id');
    const buttonPrice = section.querySelector('.wo__button-price');
    const grind = section.querySelector('.wo__grind');
    const button = section.querySelector('.wo__button');
    const formats = section.querySelectorAll('input[name="world-order-format"]');
    const updateVariant = () => {
      const format = section.querySelector('input[name="world-order-format"]:checked');
      if (!format || !grind) return;
      const key = grind.value.toLowerCase();
      variantId.value = format.dataset[`${key}Id`];
      buttonPrice.textContent = format.dataset[`${key}Price`];
      button.disabled = format.dataset[`${key}Available`] !== 'true';
    };
    formats.forEach((input) => input.addEventListener('change', updateVariant));
    grind?.addEventListener('change', updateVariant);
    updateVariant();
  });

  } catch(e) { console.error(e); }
})();
})();
